import {SuccessSVG, UnSuccessSVG} from "assets";
import React from "react";
import {ColumnsEdit} from "types/models/column-table-edit";
import "./Refunds.scss";
import {formatToCurrencyType} from "helper/common";
import moment from "moment";
import {FORMAT_TIME} from "types/enums";
import TTTTTypeColumn from "components/common/ColumnColors/KCBTypeColumn/TTTTTypeColumn";

const columnsRefunds: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "40px",
    align: "center",
  },
  {
    title: "Nội dung",
    dataIndex: "noiDung",
    key: "noiDung",
    // width: '18%',
    align: "left",
  },
  {
    title: "BH",
    dataIndex: "bh",
    key: "bh",
    width: "3%",
    align: "center",
    render: text => {
      let textTT;
      if (text == 0) {
        textTT = "Có";
      } 
      else if (text == 1) {
        textTT = "Không";
      }
      return <TTTTTypeColumn label={textTT}></TTTTTypeColumn>;
    },
  },
  {
    title: "Đơn giá BV",
    dataIndex: "donGiaBV",
    key: "donGiaBV",
    // width: '5%',
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Đơn giá BH",
    dataIndex: "donGiaBH",
    key: "donGiaBH",
    // width: '5%',
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "SL",
    dataIndex: "soLuong",
    key: "soLuong",
    width: "3%",
    align: "right",
  },
  {
    title: "Thành tiền",
    dataIndex: "thanhTien",
    key: "thanhTien",
    // width: '12%',
    align: "right",
    render: (value, record, index) => {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Ngày chỉ định",
    dataIndex: "ngayChiDinh",
    key: "ngayChiDinh",
    // width: '12%',
    align: "center",
  },
  {
    title: "Thời gian TT",
    dataIndex: "thoiGianThanhToan",
    key: "thoiGianThanhToan",
    // width: '12%',
    align: "center",
    render: (value, record, index) => {
      return <>{value ? moment(value).format(FORMAT_TIME.dateTime_3) : ""}</>;
    },
  },
  {
    title: "Tên thu ngân",
    dataIndex: "nguoiThanhToan",
    key: "nguoiThanhToan",
    // width: '12%',
    align: "left",
  },
  {
    title: "Trạng thái",
    dataIndex: "trangThai",
    key: "trangThai",
    // width: '12%',
    align: "left",
    render: text => {
      let textTT;
      if (text == 0) {
        textTT = "Đã thanh toán";
      } 
      else if (text == 1) {
        textTT = "Đã hoàn phí";
      }
      return <TTTTTypeColumn label={textTT}></TTTTTypeColumn>;
    },
  },
  {
    title: "Người đề nghị",
    dataIndex: "nguoiDeNghi",
    key: "nguoiDeNghi",
    // width: '12%',
    align: "left",
  },
  {
    title: "Hình thức hoàn phí",
    dataIndex: "idHinhThucHoanPhi",
    key: "idHinhThucHoanPhi",
    align: "left",
    render: (value, record, index) => {
      if (value == 0) {
        return "Tiền mặt"
      } 
      else if (value == 1) {
        return "Chuyển khoản"
      }
      else if (value == 2) {
        return "Quẹt thẻ"
      }
    },
  },
  {
    title: "Lý do hoàn",
    dataIndex: "lyDoHoan",
    key: "lyDoHoan",
    // width: '10%',
    align: "left",
  },
  {
    title: "TG hoàn",
    dataIndex: "thoiGianHoan",
    key: "thoiGianHoan",
    // width: '10%',
    align: "center",
  },
  // {
  //   title: "Người duyệt hoàn",
  //   dataIndex: "nguoiDuyetHoan",
  //   key: "nguoiDuyetHoan",
  //   // width: '13%',
  //   align: "right",
  // },
];

export {columnsRefunds};
